import styles from './acces.module.css';

/** Logo complet : variante couleur en jour, variante pour fond sombre en nuit (proportions d'origine 1193 x 754). */
export function LogoComplet() {
  return (
    <>
      <img className={`${styles.logo} cc-logo-jour`} src="/logo-collectivitesconnect.png" alt="CollectivitésConnect" width={190} height={120} />
      <img className={`${styles.logo} cc-logo-nuit`} src="/logo-collectivitesconnect-fond-sombre.png" alt="CollectivitésConnect" width={190} height={120} />
    </>
  );
}
